import getConfig from 'next/config'

const publicRuntimeConfig = getConfig().publicRuntimeConfig

/**
 * Gets an asset path taking in account a basePath if it is set
 * @param uri
 */
export function publicUrl(uri: string) {
  return publicRuntimeConfig.basePath
    ? uri.replace(/^\//, publicRuntimeConfig.basePath.replace(/\/?$/, '/'))
    : uri
}
